import api from './api';

export interface StudentRating {
  studentId: number;
  rating: number;
  peakRating: number;
  rankName: string;
  rankTier: number;
  totalPoints: number;
  currentStreakDays: number;
  longestStreakDays: number;
  topicsCompletedCount: number;
  quizzesPassedCount: number;
  assessmentsPassedCount: number;
  totalTimeMinutes: number;
  lastActivityDate: string;
  globalRank?: number;
  schoolRank?: number;
  classRank?: number;
}

export interface Badge {
  id: number;
  badgeCode: string;
  badgeName: string;
  description?: string;
  badgeCategory: string;
  badgeTier: string;
  iconUrl?: string;
  rarity: string;
  pointsReward: number;
  xpReward: number;
  isActive: boolean;
  earned?: boolean;
  earnedAt?: string;
  earnedCount?: number;
}

export interface Certificate {
  id: number;
  certificateCode: string;
  certificateName: string;
  description?: string;
  certificateType: string;
  templateUrl?: string;
  isActive: boolean;
  earned?: boolean;
  issuedAt?: string;
  certificateUrl?: string;
  topicId?: number;
  courseId?: number;
}

class GamificationService {
  /**
   * Get student rating and ranking
   */
  async getStudentRating(): Promise<StudentRating> {
    const response = await api.get<StudentRating>('/api/student/gamification/rating');
    return response.data;
  }

  /**
   * Get all badges for a student
   */
  async getStudentBadges(): Promise<Badge[]> {
    const response = await api.get<Badge[]>('/api/student/gamification/badges');
    return response.data;
  }

  /**
   * Award a badge to a student (typically called internally/automated)
   */
  async awardBadge(badgeCode: string): Promise<Badge> {
    const response = await api.post<Badge>(
      `/api/student/gamification/badges/${badgeCode}/award`
    );
    return response.data;
  }

  /**
   * Update student streak (called when activity is recorded)
   */
  async updateStreak(): Promise<void> {
    await api.post('/api/student/gamification/streak/update');
  }
}

export default new GamificationService();
